<script setup>
import { computed } from 'vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  id: {
    type: String,
    required: true
  },
  error: {
    type: String,
    default: null
  },
  required: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue'])

const checked = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})
</script>

<template>
  <div>
    <div class="flex items-start space-x-4 p-4 rounded-xl hover:bg-gray-50 transition-colors">
      <input
        :id="id"
        v-model="checked"
        type="checkbox"
        class="mt-1 h-5 w-5 text-brand-blue focus:ring-brand-blue border-gray-300 rounded cursor-pointer"
      />
      <label :for="id" class="text-sm text-gray-700 leading-relaxed cursor-pointer flex-1">
        <slot />
      </label>
    </div>
    <p v-if="error" class="text-xs text-red-500 ml-9 -mt-3 flex items-center">
      <span class="material-symbols-outlined text-sm mr-1">error</span>
      {{ error }}
    </p>
  </div>
</template>
